import NewsMappersFactory from '../Mappers/factory.js'
import NewsRepositoriesFactory from '../Repositories/factory.js'
import {GetFormattedNewsTagService} from './GetFormattedNewsTagService.js'
import {GetVehicleNewsService} from './GetVehicleNewsService.js'

export class NewsServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetAdDetailsAdsService}
   */
  static getFormattedNewsTagService = ({config}) =>
    new GetFormattedNewsTagService({
      config,
      fromTagsListToFormattedTagsListNewsValueObjectMapper:
        NewsMappersFactory.fromTagsListToFormattedTagsListNewsValueObjectMapper({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetVehicleNewsService}
   */
  static getVehicleNewsService = ({config}) =>
    new GetVehicleNewsService({
      config,
      repository: NewsRepositoriesFactory.hTTPNewsRepository({config})
    })
}
